// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {
  Radio,
  RadioGroup,
  FormHelperText,
  RadioGroupProps,
  FormControlLabel,
  Box,
} from '@mui/material';
import { useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  usePreviewAsButton?: boolean;
  options: {
    label: string;
    value: any;
    default?: boolean;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom' | undefined;
    preview?: any;
    size?: string;
  }[];
};

type Props = IProps & RadioGroupProps;

export default function RHFRadioGroup({ name, options, sx, usePreviewAsButton, ...other }: Props) {
  const { control } = useFormContext();
  const theme = useTheme();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} row {...other} sx={{ justifyContent: { xs: 'center', sm: 'flex-end' }, ...sx }}>
            {options.map((option, ind) => (
              <Box
                  key={option.value}
                  onClick={usePreviewAsButton ?
                      () => {field.onChange(option.value)} :
                      undefined
                  }
                  sx={
                    usePreviewAsButton ?
                        {
                          alignItems: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          mx: { xs: 2, md: 3 },
                          ml: { xs: ind === 0 ? 0 : 2, md: ind === 0 ? 0 : 3 },
                          padding: field?.value !== option?.value ? `10px` : '8px',
                          border: field?.value === option?.value ? `2px solid ${theme.palette.primary.main}` : 'none',
                        } :
                        {
                          alignItems: 'center',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          mx: { xs: 2, md: 3 },
                        }
                  }>
                {!usePreviewAsButton && option?.preview && option?.preview}
                <FormControlLabel
                  sx={{ margin: '0 auto !important' }}
                  value={option.value}
                  control={usePreviewAsButton ? option?.preview : <Radio size={option?.size as any || 'medium'} />}
                  label={option.label}
                  checked={field?.value === option?.value}
                  labelPlacement={option?.labelPlacement || 'bottom'}
                />
              </Box>
            ))}
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
